import React, { useEffect } from "react";
import { createStackNavigator } from "@react-navigation/stack";
import OtherListView from "../../views/Other/ListView/ListView";
import { STRINGS } from "../../constants";
import AttractionsMapView from "../../views/Attractions/MapView/AttractionsMapView";
import AttractionsDetailsView from "../../views/Attractions/DetailsView/AttractionsDetailsView";
import { Platform } from "react-native";
import AttractionsStore from "../../storage/attractionsStore";
import { HeaderBackButton } from "@react-navigation/elements";

const Stack = createStackNavigator();

/**
 * AttractionsStack Component
 *
 * Defines the stack navigator for the Attractions feature.
 * Includes a ListView for attractions and a MapView for location visualization.
 */
const AttractionsStack = () => {
  const fetchAttractions = AttractionsStore((state) => state.fetchAttractions);

  useEffect(() => {
    fetchAttractions();
  }, []);

  return (
    <Stack.Navigator
      initialRouteName="AttractionsListView"
      screenOptions={{
        cardStyle: { flex: 1 },
      }}
    >
      {/* Attractions ListView */}
      <Stack.Screen name="AttractionsListView" options={{ title: STRINGS.attractionsTitle, headerLeft: () => null }}>
        {() => <OtherListView type="attraction" />}
      </Stack.Screen>

      {/* Attractions MapView */}
      <Stack.Screen
        name="AttractionsMapView"
        component={AttractionsMapView}
        options={{ title: STRINGS.attractionsTitle }}
      />
      {/* DetailsView Screen - Provides details about the attraction */}
      <Stack.Screen
        name="AttractionsDetailsView"
        component={AttractionsDetailsView}
        options={({ navigation }) => {
          const canGoBack = navigation.canGoBack();
          const hideNavigationBar = Platform.OS === "android" && !canGoBack ? { headerShown: false } : {};

          return {
            ...hideNavigationBar,
            headerBackTitle: "Back",
            ...(Platform.OS === "web" && !canGoBack
              ? {
                  headerLeft: () => (
                    <HeaderBackButton
                      tintColor="#000"
                      onPress={() => {
                        window.location.href = `${window.location.origin}/attractions`;
                      }}
                    />
                  ),
                }
              : {}),
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default AttractionsStack;
